import React from 'react';
import {connect} from "react-redux";
import '../Modal/filterModal.css';
import InputSearchFilter from '../Shared/InputSearchFilter';
import SVG from "react-inlinesvg";
import searchIcon from '../../assets/icons/searchFilter.svg'
import {addSearchChips} from "../../actions/searchActions";
import link from "react-router-dom/Link";

class FilterModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: "",
            sort: "asc",
            show: false
        };

    }
    getSearchQuery = (q) => {
        this.props.setQuery(q)
    }
    handleSortChange = (e) => {
        this.setState({sort: e.target.value})
        this.props.sort(e.target.value)
    }
    componentDidMount() {
        let sort = this.props.sortOrder;

        this.setState({sort})
    }


    render(){
        return(
            <div className="search-filter-wrapper">
                <div className="search-filter-modal">
                    <div className="user-filter-name-sort-container">
                        <label id="sort-name">Sort By:</label>
                        <label htmlFor="asc-sort"><input type="radio" name="sort" id="asc-sort" value="asc" checked={this.state.sort === 'asc'} onChange={this.handleSortChange}/>Ascending</label>
                        <label htmlFor="desc-sort"><input type="radio" name="sort" id="desc-sort" value="desc" checked={this.state.sort === 'desc'} onChange={this.handleSortChange}/>Descending</label>
                    </div>
                    <div className="filterIcon-box">
                            <span className="filterIcon"><SVG src={searchIcon}/></span>
                            <InputSearchFilter sendQuery={this.getSearchQuery}/>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(null)(FilterModal);